module.exports = __webpack_public_path__ + "static/barlow-semibold-webfont-b1bca6e2e3a86a1640fc919390f8efdd.woff";